export const PATHS = {
  // Static Error Pages
  error404: '/404',
  lost: '/lost',

  // Admin Paths
  adminBecomes: (email: string = ':email') => `/admin/becomes/${email}`,

  // User Auth Paths
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  logout: '/logout',

  // Logged In User Paths
  dashboard: '/',
  settings: '/settings',
  settingDetail: (key: string = ':key') => `/settings/${key}`,

  // Lead Section Paths
  leads: '/leads',
  tasks: '/tasks',
  manageLeads: '/leads/manage',
  manageTasks: '/tasks/manage',
  leadDetail: (uuid: string = ':uuid') => `/leads/${uuid}`,
  smartViews: '/smart-views',
  filters: '/filters',
  filterWithSlug: (slug: string = ':slug') => `/filters/${slug}`,

  // Activity Section Paths
  activities: '/activities',
  manageActivities: '/activities/manage',

  guide: '/guide',

  // Automations
  automations: '/automations',
  manageAutomations: '/automations/manage',
  automationCanvas: (id: string = ':id') => `/automations/${id}`,
  automationReport: (id: string = ':id') => `/automations/${id}/report`,
  automationIndividualReport: (
    id: string = ':id',
    executionId: string = ':executionId',
  ) => `/automations/${id}/report/${executionId}`,

  // Lists
  lists: '/lists',
  manageLists: '/lists/manage',
  listDetail: (uuid: string = ':uuid') => `/lists/${uuid}`,

  // reports
  reports: '/reports',
  clockInReport: '/reports/clock-in-report',

  // requests
  requests: '/requests',
  myRequests: '/requests/my-requests',
  allRequests: '/requests/all',
};

export const DEFAULT_DB_PATH = PATHS.manageLeads;
